import React from 'react';
import './VideoSection.css';

const VideoSection = () => {
  return (
    <section className="video-section">
      <div className="video-container">
        <div className="video-header">
          <h2 className="video-title">See How It Works</h2>
          <p className="video-subtitle">Works for exams, interviews, and any proctored assessment</p>
        </div>

        <div className="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/iAjjpvsvdlU"
            title="Shadow Premium Demo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="video-iframe"
          />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
